import React from 'react';
import ActivityCard from './ActivityCard';
import SwipeableActivityCard from './SwipeableActivityCard';
import PullToRefresh from './PullToRefresh';
import MobileSkeleton from './MobileSkeleton';
import './ActivityList.css';

export default function ActivityList({ activities, view, onToggle, onEdit, onToggleActive, currentUser, onDelete, isLoading, onRefresh }) {
  // Show skeleton loading state
  if (isLoading && activities.length === 0) {
    return (
      <div className="loading-state">
        <MobileSkeleton variant="list" lines={3} />
      </div>
    );
  }

  // Show empty state
  if (!isLoading && activities.length === 0) {
    return (
      <div className="empty-state fade-in">
        <span className="empty-icon">✦</span>
        <p className="empty-title">No activities found</p>
        <p className="empty-sub">Try adjusting your filters or add a new activity.</p>
      </div>
    );
  }

  // Determine if we should use mobile components
  const isMobile = window.innerWidth <= 768;
  const CardComponent = isMobile ? SwipeableActivityCard : ActivityCard;

  const renderActivityCard = (activity, index, status) => {
    const cardProps = {
      key: activity.id,
      activity,
      onToggle,
      onEdit,
      onToggleActive,
      currentUser,
      style: { animationDelay: `${index * (isMobile ? 30 : 40)}ms` }
    };
    
    if (isMobile && onDelete) {
      cardProps.onDelete = onDelete;
    }
    
    return <CardComponent {...cardProps} />;
  };

  if (view === 'board') {
    const pending = activities.filter(a => a.status === 'pending');
    const completed = activities.filter(a => a.status === 'completed');
    
    const content = (
      <div className="board-view fade-in">
        <div className="board-col">
          <div className="board-col-header board-pending">
            <span>Pending</span>
            <span className="board-count">{pending.length}</span>
          </div>
          {pending.map((a, i) => renderActivityCard(a, i, 'pending'))}
          {isLoading && <MobileSkeleton variant="card" />}
        </div>
        <div className="board-col">
          <div className="board-col-header board-completed">
            <span>Completed</span>
            <span className="board-count">{completed.length}</span>
          </div>
          {completed.map((a, i) => renderActivityCard(a, i, 'completed'))}
          {isLoading && <MobileSkeleton variant="card" />}
        </div>
      </div>
    );
    
    // Wrap with pull-to-refresh on mobile
    if (isMobile && onRefresh) {
      return (
        <PullToRefresh onRefresh={onRefresh} isRefreshing={isLoading}>
          {content}
        </PullToRefresh>
      );
    }
    
    return content;
  }

  const listContent = (
    <div className="list-view fade-in">
      {activities.map((a, i) => renderActivityCard(a, i))}
      {isLoading && <MobileSkeleton variant="list" lines={2} />}
    </div>
  );
  
  // Wrap with pull-to-refresh on mobile
  if (isMobile && onRefresh) {
    return (
      <PullToRefresh onRefresh={onRefresh} isRefreshing={isLoading}>
        {listContent}
      </PullToRefresh>
    );
  }
  
  return listContent;
}
